import { useState } from "react";
import { useFAQsQuery } from "@/lib/queries";
import { Plus, Minus } from "lucide-react";

function Item({ q, isOpen, onClick, idx }) {
  return (
    <div className="border-b border-[#2A2A2A]" data-testid={`faq-item-${q.id}`}>
      <button
        onClick={onClick}
        aria-expanded={isOpen}
        className="w-full flex items-center justify-between py-6 text-left gap-6 group"
        data-testid={`faq-trigger-${idx}`}
      >
        <span className="font-serif text-lg md:text-xl text-white group-hover:text-[#D4AF37] transition-colors">
          {q.question}
        </span>
        <span className="shrink-0 w-9 h-9 border border-[#D4AF37]/40 text-[#D4AF37] flex items-center justify-center">
          {isOpen ? <Minus className="w-4 h-4" /> : <Plus className="w-4 h-4" />}
        </span>
      </button>
      <div
        className={`overflow-hidden transition-all duration-300 ${isOpen ? "max-h-96 pb-6" : "max-h-0"}`}
      >
        <p className="text-white/65 text-base leading-relaxed max-w-3xl" data-testid={`faq-answer-${idx}`}>
          {q.answer}
        </p>
      </div>
    </div>
  );
}

export default function FAQ() {
  const { data: items = [] } = useFAQsQuery();
  const [open, setOpen] = useState(null);

  return (
    <section id="faq" className="relative py-24 md:py-32 bg-[#0F0F0F]" data-testid="faq-section">
      <div className="max-w-5xl mx-auto px-5 md:px-10">
        <div className="text-center mb-14">
          <div className="text-[0.7rem] tracking-[0.32em] uppercase text-[#D4AF37] font-semibold mb-4">
            Frequently Asked Questions
          </div>
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl text-white" data-testid="faq-headline">
            Everything you want to know
          </h2>
        </div>

        <div>
          {items.map((q, i) => (
            <Item
              key={q.id}
              q={q}
              idx={i}
              isOpen={open === q.id}
              onClick={() => setOpen(open === q.id ? null : q.id)}
            />
          ))}
          {items.length === 0 && (
            <div className="text-center text-white/40 py-10">Loading FAQs…</div>
          )}
        </div>
      </div>
    </section>
  );
}
